// extracted by mini-css-extract-plugin
module.exports = {"begining":"tableRow_begining__1c5z_","end":"tableRow_end__TfcXD","transaction":"tableRow_transaction__1vyLR"};